
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-800 via-gray-900 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4 logo-font text-teal-300">
              Mindshift AI
            </h3>
            <p className="text-gray-300 leading-relaxed max-w-md">
              Dein vertraulicher KI-Coach für mentale Stärke, Klarheit und persönliche Entwicklung. 
              DSGVO-konform und in Deutschland gehostet.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Rechtliches</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/datenschutz" 
                  className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link 
                  to="/impressum" 
                  className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link 
                  to="/kontakt" 
                  className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Kontakt
                </Link>
              </li>
              <li>
                <a 
                  href="/#partnership" 
                  className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Kooperationen &amp; Whitelabel
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Verbindung</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://t.me/mindshift_ai_bot" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-teal-400 transition-colors flex items-center cursor-pointer"
                >
                  <i className="ri-telegram-line mr-2"></i>
                  Telegram Bot
                </a>
              </li>
              <li>
                <Link 
                  to="/dashboard" 
                  className="text-gray-300 hover:text-teal-400 transition-colors flex items-center cursor-pointer"
                >
                  <i className="ri-dashboard-line mr-2"></i>
                  Web-App
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <div className="text-gray-400 text-sm">
            © 2025 Mindshift AI. Alle Rechte vorbehalten.
          </div>
        </div>
      </div>
    </footer>
  );
}
